import { render, staticRenderFns } from "./MaterialAttributeEditDialog.vue?vue&type=template&id=e77a7fc4&scoped=true"
import script from "./MaterialAttributeEditDialog.vue?vue&type=script&lang=ts"
export * from "./MaterialAttributeEditDialog.vue?vue&type=script&lang=ts"
import style0 from "./MaterialAttributeEditDialog.vue?vue&type=style&index=0&id=e77a7fc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77a7fc4",
  null
  
)

export default component.exports